var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "app-dialer-common-popup",
    {
      key: _vm.actionsType,
      staticClass: "app-dialer-actions-popup",
      attrs: { title: _vm.title },
      on: {
        close: function ($event) {
          return _vm.$emit("close")
        },
      },
    },
    [
      _c("app-dialer-transfer-content", {
        attrs: {
          avatar: _vm.avatar,
          agents: _vm.agentOptions,
          "rule-groups": _vm.ruleGroups,
          tabs: _vm.content,
          "agent-actions-type": _vm.actionsType,
          context: _vm.context,
          statuses: _vm.statuses,
          "default-search-options": _vm.defaultSearchOptions,
          "can-change-search-options": _vm.canChangeSearchOptions,
          "show-agents-tab": _vm.showAgentsTab,
          "are-agent-actions-disabled": _vm.isPerformingAction,
          "can-invite-third-party": _vm.canInviteThirdParty,
          "tabs-type": "inline",
          "actions-type": "inline",
          size: "desktop",
        },
        on: {
          "invite-agent": _vm.onInviteAgent,
          "invite-3rd-party": _vm.onInvite3rdParty,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }